// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".style__container___2mIZU {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n}\n\n.style__dropdownHolder___RKJI4 {\n\twidth: 75px;\n\tmargin-right: 15px;\n}\n\n.style__floatText___3e9nv {\n\tdisplay: inline-block;\n\tcolor: #727272;\n\tfont-size: 14px;\n\tfont-weight: 300;\n\tfont-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n}\n\n.style__inputInput___1XYes {\n\tpadding: 0px;\n}\n\n.style__inputInput___1XYes::after {\n\tright: 3px;\n\tborder-top-color: var(--color-primary);\n}\n\n.style__inputInputElement___TCDoF {\n\tpadding-left: 5px;\n\tpadding-bottom: 5px;\n}\n\n.style__icons___rZZZ0 {\n\ttop: -10px;\n}", ""]);
// Exports
exports.locals = {
	"container": "style__container___2mIZU",
	"dropdownHolder": "style__dropdownHolder___RKJI4",
	"floatText": "style__floatText___3e9nv",
	"inputInput": "style__inputInput___1XYes",
	"inputInputElement": "style__inputInputElement___TCDoF",
	"icons": "style__icons___rZZZ0"
};
module.exports = exports;
